export const ADMIN_LOADING = "ADMIN_LOADING";
export const ADMIN_FAIL = "ADMIN_FAIL";
export const ADMIN_SUCCESS = "ADMIN_SUCCESS";
export const ADMIN_LOGOUT = "ADMIN_LOGOUT";


export interface AdminLoading {

    type: typeof ADMIN_LOADING

}

// for testing put any
// add types for response 
// then add in adminsuccess payload
export interface AdminSuccess {

    type: typeof ADMIN_SUCCESS,
    payload: any

}

export interface AdminFail {

    type: typeof ADMIN_FAIL,
    payload: any

}




export type AdminDispatchTypes = AdminLoading | AdminSuccess | AdminFail